/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueCheck = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        officialName: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        internalName: {
            type: 'any-of',
            contains: [{
                type: 'string',
            }, {
                type: 'null',
            }],
        },
        areaOfInterestCodes: {
            type: 'array',
            contains: {
                type: 'string',
            },
            isRequired: true,
        },
        sports: {
            type: 'SportEnum',
        },
        tableRating: {
            type: 'LeagueRatingEnum',
        },
        main: {
            type: 'boolean',
        },
        year: {
            type: 'number',
        },
        category: {
            type: 'LeagueCategoryEnum',
        },
    },
} as const;
